import main2 from './img/main2.webp';
import mainRight from './img/main-right.webp';
import notebook from './img/notebook.webp';
import m1 from './img/m1.webp';
import m2 from './img/m2.webp';
import o1 from './img/o1.webp';
import o2 from './img/o2.webp';
import s1 from './img/s1.webp';
import s2 from './img/s2.webp';
import s3 from './img/s3.webp';
import s4 from './img/s4.webp';
import s5 from './img/s5.webp';
import s6 from './img/s6.webp';
import t1 from './img/t1.webp';
import t2 from './img/t2.webp';
import t3 from './img/t3.webp';
import t4 from './img/t4.webp';
import t5 from './img/t5.webp';
import t6 from './img/t6.webp';
import t7 from './img/t7.webp';
import t8 from './img/t8.webp';
import t9 from './img/t9.webp';
import t10 from './img/t10.webp';
import t11 from './img/t11.webp';
import t12 from './img/t12.webp';
import t13 from './img/t13.webp';
import t14 from './img/t14.webp';
import t15 from './img/t15.webp';
import t16 from './img/t16.webp';

export const images = [
    main2,
    mainRight,
    notebook,
    m1,
    m2,
    o1,
    o2,
    s1,
    s2,
    s3,
    s4,
    s5,
    s6,
    t1,
    t2,
    t3,
    t4,
    t5,
    t6,
    t7,
    t8,
    t9,
    t10,
    t11,
    t12,
    t13,
    t14,
    t15,
    t16,
];
